export default [
  {
    position: "absolute",
    top: 17.5,
    left: 75.8,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "reportsP3.mTitleOne",
    mBody: "reportsP3.mBodyOne",
    isVideo: true,
    videoThumb: "HR-Report-Thumb",
    videoURL: "HR-Report.mp4",
    vidIcon: true,
    id: "HR_Reports_Video_NewReport",
    index: 0,
  },
  {
    position: "absolute",
    top: 57,
    left: 19,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 4,
    tooltipText: "reportsP3.ttTextFour",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_Reports_Navigation_NewStarters",
    index: 1,
  },
  {
    position: "absolute",
    top: 3,
    left: 12,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "reportsP3.ttTextOne",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_Reports_Navigation_Home",
    index: 2,
  },
  {
    position: "absolute",
    top: 3,
    left: 27.7,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "reportsP3.ttTextTwo",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_Reports_Navigation_TeamMembers",
    index: 3,
  },
  {
    position: "absolute",
    top: 3,
    left: 33.9,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "reportsP3.ttTextThree",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_Reports_Navigation_Dashboards",
    index: 4,
  },
  {
    position: "absolute",
    top: 84.5,
    left: 16.8,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-bottom-left",
    isDialog: true,
    modal: false,
    mTitle: "reportsP3.benefitsInsightsTitle",
    mBody: "reportsP3.benefitsInsightsBody",
    isVideo: true,
    videoThumb: "HR-Benefits-Insights-Thumb",
    videoURL: "HR-Benefits-Insights.mp4",
    vidIcon: true,
    id: "HR_Reports_Benefits_Insights",
    index: 4,
  },
];
